import { render, staticRenderFns } from "./NormalSearchNav134.vue?vue&type=template&id=b06dae74&scoped=true"
import script from "./NormalSearchNav134.vue?vue&type=script&lang=js"
export * from "./NormalSearchNav134.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b06dae74",
  null
  
)

export default component.exports